// Helpers for interpreting a run workout's machine-readable `segments` timeline.

// Efforts that represent a "push" (harder) phase — used to color-code the guided
// screen and to pick a more urgent audio/vibration cue on entry.
export const PUSH_EFFORTS = ["FAST", "HILL", "TEMPO", "COMFORTABLY HARD", "MODERATE", "STRIDES"];

export const isPushEffort = (e) => PUSH_EFFORTS.includes(String(e || "").toUpperCase());

export const fmtClock = (sec) => {
  const s = Math.max(0, Math.round(sec));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
};

// Expand repeat blocks into a flat, ordered list of timed phases for playback.
// Each phase: { label, effort, rpe, duration_sec, roundText? }
export function expandSegments(segments) {
  const flat = [];
  (segments || []).forEach((seg) => {
    if (seg && seg.type === "repeat") {
      const rounds = seg.rounds || 1;
      for (let r = 0; r < rounds; r++) {
        (seg.steps || []).forEach((st) => {
          flat.push({ ...st, roundText: `${r + 1}/${rounds}` });
        });
      }
    } else if (seg) {
      flat.push({ ...seg });
    }
  });
  return flat.filter((p) => (p.duration_sec || 0) > 0);
}

export function timelineTotalSec(segments) {
  return expandSegments(segments).reduce((a, p) => a + (p.duration_sec || 0), 0);
}

// Human-readable outline of the workout structure (for the detail screen).
export function describeSegments(segments) {
  const lines = [];
  (segments || []).forEach((seg) => {
    if (seg && seg.type === "repeat") {
      const steps = (seg.steps || [])
        .map((s) => `${s.label} ${fmtClock(s.duration_sec)} (RPE ${s.rpe})`)
        .join("  →  ");
      lines.push({ repeat: true, rounds: seg.rounds, text: steps });
    } else if (seg) {
      lines.push({ repeat: false, text: `${seg.label} · ${fmtClock(seg.duration_sec)} · RPE ${seg.rpe}`, effort: seg.effort });
    }
  });
  return lines;
}
